<div
  class="header h-[55px] flex justify-between items-center p-[50px] !bg-[#DEE2E6] sticky z-50 top-0"
>
  <div class="flex items-center">
    <p class="!m-0">{{labels.title}}</p>
    <p
      class="!mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] px-[13px] !h-[24px]"
    >
      Required Documentation
    </p>
  </div>
  <div>
    <mat-icon class="cursor-pointer" (click)="closeModalEvent.emit()"
      >close</mat-icon
    >
  </div>
</div>

<form class="!mt-[30px]" [formGroup]="form">
  <p class="subTitle pl-[28px]">Commercial Submission:</p>
  <p class="label pl-[28px]">Price Breakdown</p>

  <div class="!px-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1">
    <!-- <div class="rounded w-[100%] p-0 !pb-0 !pt-0">
      <mat-form-field class="!w-[50%]" appearance="outline">
        <mat-label> Title</mat-label>
        <input
          matInput
          type="text"
          formControlName="title"
          placeholder="Title"
        />
      </mat-form-field>
      <div
        *ngIf="form.get('title').invalid && form.get('title').touched"
        class=""
      >
        <span style="color: red">Title is required</span>
      </div>
    </div> -->
    <div class="rounded p-0 !pb-0 !pt-0 w-[100%] mt-[8px]">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="description_control"
          placeholder="Description"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('description_control').invalid &&
          form.get('description_control').touched
        "
      >
        <span style="color: red">Description is required</span>
      </div>
      <div class="flex items-center justify-start mt-[61px]">
        <app-file-manager
          [newFileControlName]="'priceBreakDownFileControl'"
          [oldFiles]="oldPriceBreakDownFiles"
          (newFilesUpdatedEvent)="handleNewFiles($event)"
          (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
        ></app-file-manager>
      </div>
    </div>
    <span class="label mt-[56px]"> Financial Stability </span>
    <div class="rounded p-0 !pb-0 !pt-0 w-[100%] mt-[8px]">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Financial Stability</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="financial_stability_control"
          placeholder="Financial Stability"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('financial_stability_control').invalid &&
          form.get('financial_stability_control').touched
        "
      >
        <span style="color: red">Financial stability is required</span>
      </div>
    </div>
    <div class="flex items-center justify-start mt-[61px]">
      <app-file-manager
        [newFileControlName]="'financialStabilityFileControl'"
        [oldFiles]="oldFinancialStabilityFiles"
        (newFilesUpdatedEvent)="handleNewFiles($event)"
        (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
      ></app-file-manager>
    </div>

    <span class="label mt-[18px]"> Contractual comments</span>
    <app-rich-textEditor
      (contentChange)="setContractualComments($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('contractual_comments_control')?.value"
    ></app-rich-textEditor>

    <span class="label mt-[18px]">Proof of Insurance</span>
    <div class="flex items-center justify-start mt-[14px]">
      <app-file-manager
        [newFileControlName]="'performanceBondFileControl'"
        [oldFiles]="oldPerformanceBondFiles"
        (newFilesUpdatedEvent)="handleNewFiles($event)"
        (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
      ></app-file-manager>
    </div>

    <span class="label mt-[18px]">Performance Bond/Guarantee</span>
    <div class="flex items-center justify-start mt-[14px]">
      <app-file-manager
        [newFileControlName]="'proofOfInsuranceFileControl'"
        [oldFiles]="oldProofOfInsuranceFiles"
        (newFilesUpdatedEvent)="handleNewFiles($event)"
        (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
      ></app-file-manager>
    </div>
  </div>

  <div
    class="!pr-[32px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button (click)="handleBack()" type="button" class="back-btn">
        Back
      </button>
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="moveToNextStep()"
      >
        Next
      </button>
    </div>
  </div>
</form>
